import { resetActiveTime } from '../times/actions';
import { SET_ACTIVE_DAY } from '../constants';

/**
 * By reset time on SET_ACTIVE_DAY action.
 * resetActiveTime is called inside middleware, and not
 * inside action in order to prevent racing condition.
 */
const resetTimeOnSetActiveDay = () => next => (action) => {
  if (action.type === SET_ACTIVE_DAY) {
    next(action);
    return next(resetActiveTime());
  }
  return next(action);
};

export default resetTimeOnSetActiveDay;



// WEBPACK FOOTER //
// ./src/app/middlewares/resetTimeOnSetActiveDay.js